<template>
  <div>
    <div class="nav-height">
      <div class="col-12 ml-3 ml-lg-1 no-gutters d-flex justify-content-end">
        <div class="d-flex mr-lg-4">          
          <div class="mt-3 ml-2 mr-3 ml-md-3">
            <div class="mouseover" v-if="!companyDetails.companyLogoLink && !companyDetails.userProfilePicture">
              <img
                v-popover:foo1
                src="../assets/AddPhoto.svg"
                class="img-lg-fluid usericon"
                id="profilepopupimg"
                alt="companylogo"
              />
            </div>
            <div v-if="companyDetails.companyLogoLink" class="profile-border mouseover">
              <img :src="companyDetails.companyLogoLink" v-popover:foo1 id="profilepopupimg" alt="companylogo" class="img-lg-fluid userproicon rounded-circle loadingBgImg">
            </div>
            <div v-if="companyDetails.userProfilePicture" class="profile-border mouseover">
              <img :src="companyDetails.userProfilePicture" v-popover:foo1 id="profilepopupimg" alt="companylogo" class="img-lg-fluid userproicon rounded-circle loadingBgImg">
            </div>
            <popover name="foo1" class="userpopover">
              <div class="p-2">
                <div class="row no-gutters">
                  <div class="col-3" v-if="moduleType=='Recruiter'">
                    <img v-if="!companyDetails.userProfilePicture" src="../assets/Profile_placehlder.svg" alt="companylogo" class="img-fluid" />
                    <img v-if="companyDetails.userProfilePicture" :src="companyDetails.userProfilePicture" alt="companylogo" oncontextmenu="return false" class="img-fluid rounded-circle loadingBgImg">
                  </div>
                  <div class="col-3" v-else>
                    <img v-if="!companyDetails.companyLogoLink" src="../assets/Profile_placehlder.svg" alt="companylogo" class="img-fluid" />
                    <img v-if="companyDetails.companyLogoLink" :src="companyDetails.companyLogoLink" alt="companylogo" oncontextmenu="return false" class="img-fluid rounded-circle loadingBgImg">
                  </div>
                  <div class="col ml-2 mt-2" v-if="moduleType=='Recruiter'">
                    <label class="d-flex flex-column text-capitalize">
                      <span class="fontsize16 black30 proximanova-bold" v-if="!companyDetails.firstName">Profile Name</span>
                      <span class="fontsize16 black30 proximanova-bold text-capitalize" v-else>{{companyDetails.firstName}} {{companyDetails.lastName}}</span>
                      <span class="fontsize12 black30 proximanova-bold" v-if="!companyDetails.companyprofiledata">Company Name</span>
                      <span class="fontsize12 black30 proximanova-bold" v-else>
                        <span class="fontsize12 black30 proximanova-bold">{{companyDetails.companyprofiledata.companyName}}</span>
                      </span>
                    </label>
                  </div>
                  <div class="col ml-2 mt-2" v-else>
                    <label class="d-flex flex-column text-capitalize">
                      <span class="fontsize16 black30 proximanova-bold" v-if="!companyDetails.companyName">Profile Name</span>
                      <span class="fontsize16 black30 proximanova-bold" v-else>{{companyDetails.companyName}}</span>
                      <span class="fontsize12 black30 proximanova-bold" v-if="!companyDetails.industry">Industry</span>
                      <span class="fontsize12 black30 proximanova-bold" v-else>{{companyDetails.industry}}</span>
                    </label>
                  </div>
                </div>                
                <div class="ml-1 pl-2 p-1 mt-2 mouseoveranimate" v-if="moduleType!=='Recruiter'" @click="navToMyProfile">
                  <img
                    src="../assets/ProfileDetails.svg"
                    alt="profile"
                    class="img-fluid mr-2 pointer"
                  />
                  <label class="font12-bold ml-1 pointer proximanova">View My Profile</label>
                </div>
                <div class="ml-1 pl-2 p-1 mt-2 mouseoveranimate" v-if="moduleType=='Recruiter'" @click="navToEditProfile">
                  <img
                    src="../assets/ProfileDetails.svg"
                    alt="profile"
                    class="img-fluid mr-2 pointer"
                  />
                  <label class="font12-bold ml-1 pointer proximanova" v-if="companyprofileId">Edit Profile</label>
                  <label class="font12-bold ml-1 pointer proximanova" v-else>Create Profile</label>
                </div>
                <div class="line ml-1"></div>
                <!-- <div class="mb-1 pl-2 p-1 mouseoveranimate" @click="navToPrivacy">
                  <img
                    src="../assets/PrivacySettings.svg"
                    class="img-fluid mr-2 pointer"
                  />
                  <label class="font12-bold pointer proximanova">Privacy Settings</label>
                </div> -->
                <div class="mb-3 pl-2 p-1 mouseoveranimate">
                  <img
                    src="../assets/SignOut.svg"
                    alt="signout"
                    class="img-fluid mr-2 pointer"
                    @click="logout"
                  />
                  <label class="font12-bold pointer proximanova" @click="logout">Sign Out</label>
                </div>
              </div>
            </popover>
          </div>
          <div class="mt-3 mr-2 ml-md-1 ">
            <div class="circle-button">
            <!-- <span @click="downloadHelpBrochure">
              <img src="../assets/Help.svg" class="help " alt="help"/>
            </span> -->
            <img v-popover:helppop src="../assets/Help.svg" width="32px" id="helppopupicon" class="help mt-1" alt="help"/>
            </div>
            <popover name="helppop" class="helppopover">
              <div class="p-2">
                <div class="pl-2 p-1 mouseoveranimate" @click="downloadHelpBrochure">
                  <img src="../assets/help.png" width="30px" class="img-fluid mr-2 pointer" alt="help"/>
                  <label class="fontsize12 proximanova-semibold black ml-1 pointer">Help </label>
                </div>
                <div class="mb-1 pl-2 p-1 mouseoveranimate" @click="NavToReportIssue">
                  <img src="../assets/PrivacySettings.svg" class="img-fluid mr-2 pointer" alt="settings"/>
                  <label class="fontsize12 proximanova-semibold black pointer">Support Center</label>
                </div>
              </div>
            </popover>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import httpuserdetails from "@/js/http-userdetails.js";
import httpbusiness from "@/js/http-business.js";
import httpjob from "@/js/http-postjob.js";
import router from '../router'
import { bus } from "@/main.js";
import $ from 'jquery'
import wndata from '../js/wn_data.json'
import sessionUtils from "@/js/session-util.js";
export default {
  data() {
    return {
      //company details
      businessAccountId : null,
      companyprofileId: null,
      moduleType : null,
      companyDetails : {},
      remainingDaysLeft : null,
      userPrivacyVersion : null,
      userTermsConditionVersion : null,
      updateVersioonModal : false,
    };
  },
  components: {
    
  },
  created() {
    this.businessAccountId = sessionUtils.getBusinessAccountId();
    // this.companyprofileId = sessionUtils.getCompanyProfileId();
    this.moduleType = sessionUtils.getmodule()
    if(this.moduleType == 'Recruiter'){
      this.getRecruiterData()
    }else{
      this.getCompanyData()
    }
    bus.$on('updateCompanyProfileInformation', (data) => {
      if(data){
        this.getRecruiterData()
      }
    })
    //this.getUserTermsandPrivacyVersions()
  },
  methods: {
    // getUserTermsandPrivacyVersions() {
    //   httpuserdetails.get("/getuserdataById?userId="+this.businessAccountId)
    //   .then((response) => {
    //     console.log("user deatils : ", response)
    //     this.userPrivacyVersion = response.data.privacyPolicyVersion;
    //     this.userTermsConditionVersion = response.data.termsConditionsVersion;
    //   }).catch((e) => {
    //     console.log(e)
    //   })
    // },
    downloadHelpBrochure(){
      document.getElementById('helppopupicon').click()
      var link=document.createElement('a');
      document.body.appendChild(link);
      link.href="./Business_help_center.pdf"
      link.target = '_blank';
      link.click();
    },
    NavToReportIssue() {
      document.getElementById('helppopupicon').click()
      this.$router.push({
        name : 'reportissue'
      })
    },
    navToMyProfile : function() {
      document.getElementById('profilepopupimg').click()
      // router.push({
      //   name : 'welcome'
      // })
      var x = document.createElement('a')
      x.target = '_blank'
      x.href = wndata.companyAccountWebapp;
      x.click()
    },
    navToEditProfile : function(){
      document.getElementById('profilepopupimg').click()
      if(this.companyprofileId != 'null' && this.companyprofileId != 'undefined'){
        router.push({
          name : 'editprofile'
        })
      }else{
        router.push({
          name : 'createprofile'
        })
      }
    },
    TryPremium : function() {
      document.getElementById('profilepopupimg').click()
      // router.push({
      //   name : 'Premium'
      // })
    },
    navToPrivacy : function() {
      document.getElementById('profilepopupimg').click()
      router.push({
        name : 'privacy'
      })
    },
    getRecruiterData() {
      httpjob.get('postjob/getCompanyEmployeeDetails?businessAccountId='+this.businessAccountId)
      .then((response) => {
        console.log("recruiter data : ", response)
        this.companyDetails = response.data;
        if(this.companyDetails && this.companyDetails.companyprofiledata){
          this.companyprofileId = this.companyDetails.companyprofiledata.companProfileId;
          sessionUtils.setCompanyProfileId(response.data.employeeId)
          sessionUtils.setRecruiterCompanyName(this.companyDetails.companyprofiledata.companyName)
          sessionUtils.setRecruiterCompanyBusinessaccountId(this.companyDetails.companyprofiledata.businessAccountId)
          sessionUtils.setRecruiterCompanyprofileId(this.companyDetails.companyprofiledata.companProfileId)
          sessionUtils.setRecruiterAccountStatus(this.companyDetails.status)
        }
      }).catch((e) => {
        console.log(e.response)
      })
    },
    getCompanyData(){
      httpbusiness.get('/business/getcompanyProfileData?businessAccountId='+this.businessAccountId)
      .then((response) => {
        console.log(response)
        this.companyDetails = response.data;
        this.companyprofileId = response.data.companyProfileId;
        sessionUtils.setCompanyProfileId(this.companyprofileId)
        sessionUtils.setRecruiterCompanyName(this.companyDetails.companyName)
      }).catch((e) => {
        console.log(e)
      })
    },
    logout: function() {
      //make a rest call to capture a logout for the user
      this.$store.state.notificationCount = 0
      this.$session.clear();
      localStorage.setItem('isLoggedin', false);
      this.$session.destroy();
      localStorage.clear();
      this.$router.push("/");
      location.reload(true)
    }
  }
};
</script>
<style scoped>
.loadingBgImg{
  background: transparent url('../assets/loading_gif1.gif') center no-repeat;
  background-size: 30px 30px;
}
.tryPremiumbtn1{
  font-size: 13px;
  padding: .2rem .45rem !important;
}
.nav{
  flex-wrap: unset !important;
}
.mouseoveranimate:hover{
  background-color:rgba(221, 223, 229,0.4);
  border-radius: 5px;
}
.userpopover.vue-popover.dropdown-position-bottom:before{
    display: none;
}
.userpopover.dropdown-position-bottom {
  left: unset !important;
  top: 50px !important;
  width: 250px !important;
  padding: 10px 10px 10px 10px !important;
  transform: translate3d(-80%, 10px, 10px) !important;
}
p{
  margin-bottom: 0 !important;
}
.circle-button{
  border-radius: 50%;
  padding: 0 5px 5px 5px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.circle-button:hover{
  animation: circle-anim 0.3s ease forwards;
  transition: all 0.4s ease;
}
.line {
  display: block;
  height: 1px;
  border: 0;
  border-top: #dddfe5;
  margin: 1em 0;
  padding: 0;
  width: 224px;
  opacity: 0.6;
  background-color: #dddfe5;
}
.mouseover{
  padding: 3px;
  transition: all 0.2s ease;
}
.usericon{
  width: 34px;
  height: 34px;
  margin-top: .085em;
  z-index: 0;
}
.mouseover:hover{
  animation: circle-anim1 0.3s ease forwards;
  transition: all 0.4s ease;
}
@keyframes circle-anim1{
  0% {
    background-color: white;
  }
  100%{
    background-color: #F0F2F5;
  }
}
.userproicon {
  cursor: pointer;
  width: 33px;
  height: 33px;
  margin-top: .085em;
}
.profile-border{
  padding: 0px 1px 1px 1px;
  border: 2px solid #ced4da;
  border-radius: 50%;
}
.profile-border:hover {
  border: 2px solid gray;
}
/* help popup */
.dropdown-position-bottom.helppopover{
  top: 71px !important;
  width: 220px !important;
  padding: 10px 10px 0px 10px !important;
  left: 85% !important;
}
.vue-popover.dropdown-position-bottom.helppopover:before {
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-bottom: 8px solid #fff;
  top: -8px;
  /* right: 50px; */
  left: 150px !important;
  filter: drop-shadow(0px -2px 2px rgba(52, 73, 94, 0.1));
}
@media screen and (min-width: 300px) and (max-width: 400px) {
  .profile-border{
    padding: 1px 1px 1px 1px;
  }
  /* help popover */
  .dropdown-position-bottom.helppopover{
    left: 35% !important;
  }
  .vue-popover.dropdown-position-bottom.helppopover:before {
    left: 190px !important;
  }
}
@media screen and (min-width: 300px) and (max-width: 400px) {
  .usericon {
    width: 35px;
    height: 35px;
    margin-top: 0;
  }
  .userproicon {
    width: 33px;
    height: 33px;
    margin-top: 0;
  }
}
@media screen and (min-width: 400px) and (max-width: 500px) {
  .mouseover{
    margin-right: 10px !important;
  }
  .profile-border{
    padding: 1px 1px 1px 1px;
  }
}

@media screen and (min-width: 400px) and (max-width: 600px) {
  .usericon {
    width: 35px;
    height: 35px;
    margin-top: 0;
  }
  .userproicon {
    width: 33px;
    height: 33px;
    margin-top: 0;
  }
   /* user popover */
  .dropdown-position-bottom.helppopover {
    left: 40% !important;
  }
  .vue-popover.dropdown-position-bottom.helppopover:before {
    left: 200px !important;
  }
}
@media screen and (max-width: 600px) and (min-width: 500px) {
  /* help popover */
  .dropdown-position-bottom.helppopover {
    left: 42% !important;
  }
  .vue-popover.dropdown-position-bottom.helppopover:before {
    left: 80% !important;
  }
}
@media screen and (max-width: 900px) and (min-width: 600px) {
  .badge{
    margin-left: -3% !important;
  }
  .profile-border{
    padding: 0px 1px 1px 1px;
  }
  /* help popver */
  .dropdown-position-bottom.helppopover {
    left: 500px !important;
  }
  .vue-popover.dropdown-position-bottom.helppopover:before {
    left: 175px !important;
  }

}
</style>
